import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IWorkingCopyService = ( createDecorator('workingCopyService'));
export { IWorkingCopyService };
